import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  API_GET_ALL_METADATA,
  API_GET_METADATA_BY_ID,
  API_POST_METADATA_,
} from '../../api/metadata.service';

export const fetchAllMetadata = createAsyncThunk(
  'metadata/fetchAll',
  async ({ page = 0, limit = 10 }, { rejectWithValue }) => {
    try {
      const response = await API_GET_ALL_METADATA(page, limit);
      return response;
    } catch (error) {
      return rejectWithValue(error?.message || error);
    }
  },
);

export const fetchMetadataById = createAsyncThunk(
  'metadata/fetchById',
  async (metadataId, { rejectWithValue }) => {
    try {
      const response = await API_GET_METADATA_BY_ID(metadataId);
      return response;
    } catch (error) {
      return rejectWithValue(error?.message || error);
    }
  },
);

export const createMetadata = createAsyncThunk(
  'metadata/create',
  async ({ fbCode }, { rejectWithValue }) => {
    try {
      const response = await API_POST_METADATA_(fbCode);
      return response;
    } catch (error) {
      return rejectWithValue(error?.message || error);
    }
  },
);
